export default __webpack_public_path__ + "static/bedsheet-af7af52b4b9d1bf2ee0f19ad56564a4b.jpg";